import { createFileRoute } from '@tanstack/react-router';
import { ProductsPage } from '@/pages/menu/products';
import { requireAuth } from '../require-auth';
import { menuSearchSchema } from '../menu-search';

// No loader prefetch: the catalog is keyed by the active branch, which is only
// known once the branch list has loaded (see `useMerchantScope`). Prefetching
// here would either fire with an empty scope or duplicate the branch request,
// so the page's own query owns the fetch.
export const Route = createFileRoute('/eats/menu_/products')({
  // Auth guard — see `require-auth.ts`. Runs before the component mounts,
  // so no query fires without a session.
  beforeLoad: requireAuth,
  validateSearch: menuSearchSchema,
  component: ProductsRoute,
});

function ProductsRoute() {
  const { search, status, categoryId, branchId, allBranches, showcase } =
    Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <ProductsPage
      search={search}
      status={status}
      categoryId={categoryId}
      branchId={branchId}
      allBranches={allBranches ?? true}
      showcase={showcase ?? false}
      onSelectAllBranches={(next) => {
        void navigate({
          search: (prev) => ({
            ...prev,
            allBranches: next ? undefined : false,
            branchId: undefined,
          }),
        });
      }}
      onSelectBranch={(id) => {
        void navigate({
          search: (prev) => ({
            ...prev,
            branchId: id,
            allBranches: false,
          }),
        });
      }}
      onToggleShowcase={() => {
        void navigate({
          search: (prev) => ({
            ...prev,
            showcase: prev.showcase ? undefined : true,
          }),
        });
      }}
    />
  );
}
